module.exports = __webpack_public_path__ + "img/13中国招投标协会会员.f84b7675.jpg";